const MyFn = {
  resetRigthSize(){
    let getHeight = this.getRightHeight();
    /* $(window).resize(()=>{
      getHeight = this.getRightHeight(type);
    }); */
    //console.log(getHeight,'== 当前高度 =');
    return getHeight;
  },
  //动态获取右侧高度
  getRightHeight(){
    //type 1 是获取 类似 采购入库 下数据明细 高度
    let rightWidth = $('.right_main').width() ? $('.right_main').width() : 0;
    //右侧整个高度
    let rightHeight = $('.right_body').height() ? $('.right_body').height() : $(window).height() - 140;
    //当前位置
    let activeRumb = $('.active_rumb').height() ? $('.active_rumb').height() : 0;
    //搜索高度
    let searchHeight = $('.search_box').height() ? $('.search_box').height() : 0;
    //操作按高度
    let actionheight = $('.tab_action').height() ? $('.tab_action').height() : 0;
    //抬头信息
    let headerBox = $('.header_box').height() ? $('.header_box').height() + 20 : 0;


    //明细高度
   let listHeight = $('.list_content').height() ? 30 : 0;


    //页码高度
    let pagesHeight = $('.pages_box').height() ? 50 : 20;

    let nsg = {
      "rightHeight":rightHeight,
      "activeRumb" : activeRumb,
      "searchHeight":searchHeight,
      "headerBox":headerBox,
      "actionheight":actionheight,
      "pagesHeight":pagesHeight
    };
    console.log(nsg);
    return rightHeight - activeRumb - searchHeight - headerBox - actionheight - pagesHeight - listHeight - 20;

  },
  //根据指定字段排序
  compare(property){
    return function(a,b){
      var value1 = a[property];
      var value2 = b[property];
      return value1 - value2;
    }
  },
  //递归成树状 - 资源
  resourceTree(data, parent,level = 0){
    level++;
    var tree = [];
    var temp;
    for (var i = 0; i < data.length; i++) {
      if (data[i].parentResourceId == parent) {
        let levelStr = "";
        for(var j=1;j<level;j++){
          levelStr = levelStr + '|- ';
        }
        data[i].level = level;
        data[i].value = levelStr + data[i].resourceName;
        var obj = data[i];
        temp = this.resourceTree(data, data[i].resourceId,level);
        if (temp.length > 0) {
          obj.children = temp;
        }
        tree.push(obj);
      }
    }
    return tree;
  }
};
MyFn.install = function (Vue) {
  Vue.prototype.$myfn = MyFn;
}
export default MyFn;
